import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";
import { useMutation } from "@apollo/react-hooks";
import { InputAdornment, TextField } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import SendIcon from "@iconify/icons-mdi/send";
import { InlineIcon } from "@iconify/react";
import { MY_TIME_CREATE_MESSAGE } from "my-time/graphql";
import { myTimeMessageState } from "my-time/states/my-time-message";
import { useOcCurrentUserState } from "oc/hooks";

interface MyTimeNewMessageProps {
  loading: boolean;
  selectedRequest: string;
  disabled?: boolean;
}

export const MyTimeNewMessage = ({
  loading,
  selectedRequest,
  disabled = false,
}: MyTimeNewMessageProps) => {
  const { t } = useTranslation();
  let { employeeCode: employee } = useOcCurrentUserState();
  const theme = useTheme();

  const [message, setMessage] = useRecoilState(myTimeMessageState);
  const [error, setError] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMessage(e.target.value);
  };

  const [createMyTimeMessage] = useMutation(MY_TIME_CREATE_MESSAGE);

  const handleSubmit = () => {
    const params = {
      request: selectedRequest,
      message: message,
      employee: employee,
    };
    createMyTimeMessage({
      variables: params,
    });
    setMessage("");
  };

  return (
    <TextField
      id="new-message-box-input"
      multiline={message?.length > 50 ? true : false}
      fullWidth
      variant="outlined"
      placeholder={t("OC_WRITE_MESSAGE")}
      value={message}
      onChange={handleChange}
      onFocus={() => setError(false)}
      error={error}
      helperText={error ? `${t("OC_EMPTY_MESSAGE")}` : `${message.length}/255`}
      style={{
        height: "auto",
      }}
      disabled={disabled}
      inputProps={{ maxLength: 255 }}
      FormHelperTextProps={
        error
          ? { style: { textAlign: "left" } }
          : { style: { textAlign: "right" } }
      }
      InputProps={{
        disabled: loading || disabled,
        style: {
          backgroundColor: "white",
        },
        endAdornment: (
          <InputAdornment position="end">
            <InlineIcon
              id="my-time-new-message-button"
              icon={SendIcon}
              onClick={handleSubmit}
              width="22px"
              height="22px"
              style={{
                cursor: "pointer",
                backgroundColor: theme.palette?.gray20?.main,
                color: theme.palette?.gray60?.main,
                padding: "13px",
                borderRadius: "25px",
              }}
            />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default MyTimeNewMessage;
